export class RequestResponse {
  request: string;
  response: string;
  responseLength: number;
  endpoint: string;

  constructor();
  constructor(
    request: string | null,
    response: string | null,
    responseLength: number | null,
    endpoint: string | null
  );
  constructor(
    request?: string | null,
    response?: string | null,
    responseLength?: number | null,
    endpoint?: string | null
  ) {
    this.request = request ?? '';
    this.response = response ?? '';
    this.responseLength = responseLength ?? 0;
    this.endpoint = endpoint ?? '';
  }
}
